module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "allpage"
  }, [_c('div', {
    staticClass: "allpages"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "bottomPart"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "centerPart"
  }, [_c('div', {
    staticClass: "bottomLeft",
    on: {
      "click": function($event) {
        _vm.stepone()
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/sq1.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "house",
    attrs: {
      "src": require("../assets/wyckc.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "insReport"
  }, [_vm._v(_vm._s(_vm.language.woyaochakucun))])]), _vm._v(" "), _c('div', {
    staticClass: "bottomRight"
  }, [_c('div', {
    staticClass: "bottomright_top",
    on: {
      "click": _vm.stepTwo
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/sq2.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "cart",
    attrs: {
      "src": require("../assets/wyth.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "pick"
  }, [_vm._v(_vm._s(_vm.language.woyaotihuo))])]), _vm._v(" "), _c('div', {
    staticClass: "bottomright_bottom",
    on: {
      "click": _vm.stepThree
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/sq3.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "process",
    attrs: {
      "src": require("../assets/wyjg.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "Wanprocess"
  }, [_vm._v(_vm._s(_vm.language.woyaojiagong))])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "topPart"
  }, [_c('div', {
    staticClass: "topimg"
  }, [_c('img', {
    staticClass: "topbar",
    attrs: {
      "src": require("../assets/topbarbg(1).jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/font.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "titright"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/mans.png"),
      "alt": ""
    }
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vessel"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/background.jpg"),
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3ec9b8dd!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/firstpage.vue
// module id = 912
// module chunks = 1